<template>
    <div class="main">
        <servicesBanner></servicesBanner>
       <div class="main-content-center">
             <div class="dinner" ref="dinner">
                <div class="experiences-title">Dinner</div>
                <div class="experiences-content">
                    <div class="experiences-content-item" v-for="(item,index) in dinnerList" :key="item.id" :ref="'dinnerItem' + index"> 
                        <img loading="lazy" :class="{'banner-fade-in': isVisibleDinner[index]}" :src="item.img" alt="">
                        <div class="bottom" :class="{'animate': isVisibleDinner[index]}">
                            <div class="experiences-content-item-title">{{item.title}}</div>
                            <div class="experiences-content-item-desc">{{item.desc}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bodyguardservices">
                <div class="experiences-title">{{bodyguardservicesInfo.title}}</div>
                <div class="experiences-desc">{{bodyguardservicesInfo.desc}}</div>
                <div class="accommodations-list-item" v-for="(item,index) in bodyguardservicesInfo.list" :key="item.id" :ref="'bodyguardservicesItem' + index">
                    <div class="left" :class="{'animateX': isVisible[index]}"><img loading="lazy"  :src="item.img" alt="" :class="{'banner-fade-in':isVisible[index]}"></div>
                    <div class="right" :class="{'diff-right':item.id == 1,'animateRight': isVisible[index]}">
                        <div class="lable" v-show="item.id != 1"><span>——</span>Other services</div>
                        <div class="title" v-show="item.id != 1">{{item.title}}</div>
                        <div class="right-content" v-for="items in item.itemList" :key="items.id">
                            <div class="title" v-show="items.title" :class="{'diff-title':item.id == 1}">{{items.title}}</div>
                            <div class="desc">
                                <span class="desc-num" v-show="item.id != 1"></span>
                                <div  :class="{'diff-desc':item.id == 1,'desc-text':item.id != 1}">{{items.desc}}</div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
            <div class="wedding-photography" ref="weddingPhotography">
                <div class="wedding-photography-title">{{weddingPhotographyInfo.title}}</div>
                <div class="wedding-photography-list">
                    <div class="wedding-photography-list-item" 
                    v-for="item in weddingPhotographyInfo.list" 
                    :key="item.id"
                    :class="{'banner-fade-in':isAnimate && item.id == 2,'animateX':isAnimate && item.id == 1,'animateRight':isAnimate && item.id == 3}"
                    >
                        <div class="top"><img loading="lazy"  :src="item.img" alt=""></div>
                        <div class="bottom">{{item.desc}}</div>
                    </div>
                </div>
            </div>
       </div>
        <footerComponentVue></footerComponentVue>
    </div>
</template>
<script>
import servicesBanner from '/components/pc/headerComponent/servicesBanner.vue'
import dinner from '/js/experience/services/dinner.js'
import bodyguardServices from '/js/experience/services/bodyguardServices.js'
import weddingPhotography from '/js/experience/services/weddingPhotography.js'
import footerComponentVue from '/components/pc/footerComponent/footerComponent.vue'
export default {
    components:{
        servicesBanner,
        footerComponentVue
    },
    data(){
        return {
            dinnerList:dinner.dinnerList,
            bodyguardservicesInfo:bodyguardServices.bodyguardServicesInfo,
            weddingPhotographyInfo:weddingPhotography.weddingPhotographyInfo,
            isVisibleDinner:[],
            isVisible:[],
            isAnimate:false
        }
    },
    mounted(){

         // 观察 bodyguardservices 列表项
        this.dinnerList.forEach((_, index) => {
            const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                // 设置当前元素为可见
                this.$set(this.isVisibleDinner, index, true);
                observer.unobserve(entry.target); // 停止观察该元素
                }
            });
            }, { threshold: 0.1 });

            // 获取当前索引的元素并开始观察
            const element = this.$refs['dinnerItem' + index][0];
            if (element) {
                observer.observe(element);
            }
        });
        // // 观察 bodyguardservices 列表项
        this.bodyguardservicesInfo.list.forEach((_, index) => {
            const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                // 设置当前元素为可见
                this.$set(this.isVisible, index, true);
                observer.unobserve(entry.target); // 停止观察该元素
                }
            });
            }, { threshold: 0.1 });

            // 获取当前索引的元素并开始观察
            const element = this.$refs['bodyguardservicesItem' + index][0];
            if (element) {
            observer.observe(element);
            }
        });
        const observers = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                // 当 .Popular-products 进入视口时触发动画
                if (entry.isIntersecting) {
                    this.isAnimate = true;
                    observers.unobserve(entry.target); // 只触发一次
                }
            });
        }, { threshold: 0.1 }); // 触发时，至少 10% 的元素进入视口

        // 开始观察
        observers.observe(this.$refs.weddingPhotography);
    },
}
</script>
<style scoped lang="scss">
@import '/style/pc/common/animateX.scss';
@import '/style/pc/common/animateRight.scss';
@import '/style/pc/common/animate.scss';
@import '/style/pc/common/fadeIn.scss';
@import '/style/phone/experience/services/services.scss';
    .main{
        .main-content-center{
            margin: 0 auto;
            width: 75rem;
        }
         .dinner{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 5.625rem;
            .experiences-title{
                color: #09080D;
                font-size: 2.5rem;   
                font-weight: 700;
                text-align: center;
                margin-bottom: 0.5rem;
                font-family: Butler;
            }
            .experiences-content{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .experiences-content-item{
                    background: #F4F4F6;
                    width: 36.6875rem;  
                    height: 100%;
                    border-radius: 0.5rem;
                    margin-top: 2.5rem;
                    img{
                        width: 100%;
                        height: 18rem;  
                        display: block;
                        border-radius: 0.5rem 0.5rem 0 0;   
                    }
                    .bottom{
                        min-height: 7.125rem;
                        padding: 1rem;  
                        .experiences-content-item-title{
                            color: #09080D;
                            font-size: 1.75rem;  
                            font-weight: 700;
                            font-family: Butler;
                            font-feature-settings: 'liga' off, 'clig' off;
                            text-transform: capitalize;
                        }
                        .experiences-content-item-desc{
                            color: #44444C;
                            font-family: Inter;
                            font-size: 1rem;  
                            font-weight: 300;
                        }
                    }
                }
            }
        }
        .bodyguardservices{
            padding-top: 5.625rem;
            .experiences-title{
                color: #09080D;
                text-align: center;
                font-feature-settings: 'liga' off, 'clig' off;
                font-size: 2.5rem;
                font-style: normal;
                font-weight: 700;
                line-height: 120%; /* 48px */
                text-transform: capitalize;
                margin-bottom: 0.5rem;
                font-family: Butler;
            }
            .experiences-desc{
                color: #09080D;
                text-align: center;
                font-family: Inter;
                font-size: 1.25rem;
                font-weight: 400;
                line-height: 150%; /* 30px */
                margin-bottom: 2.5rem;
            }
            .accommodations-list-item:nth-child(2n){
                flex-direction: row-reverse;
            }
            .accommodations-list-item{
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 22.125rem;
                margin-bottom: 5.625rem;
                .left{
                    width: 36.875rem;
                    height: 100%;
                    img{
                        width: 100%;
                        height: 100%;
                        border-radius: 0.125rem;
                    }
                }
                .right{
                    width: 35.375rem;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    .lable{
                        color: #7D7C84;
                        font-family: Inter;
                        font-size: 1rem;
                        font-weight: 300;
                        text-transform: capitalize;
                        margin-bottom: 1rem;
                        span{
                            margin-right: 0.75rem;
                        }
                    }
                    .title{
                        color: #09080D;
                        font-feature-settings: 'liga' off, 'clig' off;
                        font-size: 2rem;
                        font-weight: 700;
                        line-height: 1.2;
                        text-transform: capitalize;
                        margin: 0 0 0.875rem 0;
                        font-family: Butler;
                    }
                    .desc{
                        display: flex;
                        justify-content: space-between;
                         .desc-num{
                            display: block;
                            width: 0.625rem;
                            height: 0.625rem;
                            background-color: #09080D;
                            border-radius: 50%;
                            margin-right: 1.25rem;
                            margin-top: 0.625rem;
                        }
                        .desc-text{
                            color:  #09080D;
                            font-family: Inter;
                            font-size: 1.25rem;
                            font-weight: 300;
                            line-height: 1.5;
                            width: calc(100% - 0.625rem);
                        }
                    }
                }
                .diff-right{
                    justify-content: space-between;
                }
                .diff-desc{
                    color:#5E5D65;
                    font-family: Inter;
                    font-size: 1rem;
                    font-weight: 300;
                    line-height: 150%; /* 24px */
                }
                .diff-title{
                    font-size: 1.5rem ;
                    margin: 0 0 0.875rem 0 ;
                    font-family: Butler;
                    font-weight: 500;
                }
            }
        }
        .wedding-photography {
            margin-bottom: 5.625rem; /* 90px */
            .wedding-photography-title {
                color: #09080D;
                text-align: center;
                font-feature-settings: 'liga' off, 'clig' off;
                font-size: 2rem; /* 32px */
                font-weight: 700;
                line-height: 1.2; /* 38.4px */
                text-transform: capitalize;
                margin-bottom: 2.5rem; /* 40px */
                font-family: Butler;
            }
            .wedding-photography-list {
                display: flex;
                justify-content: space-between;
                .wedding-photography-list-item {
                    width: 24rem; /* 384px */
                    img {
                        width: 100%;
                        height: 14.5rem; /* 232px */
                    }
                    .bottom {
                        margin-top: 1.5rem; /* 24px */
                        color: #09080D;
                        font-family: Inter;
                        font-size: 1.25rem; /* 20px */
                        font-style: normal;
                        font-weight: 300;
                        line-height: 1.6; /* 32px */
                    }
                }
            }
        }    
    }
</style>